import {CardGridSingleLineNew} from "@laser-project/kyui";
import React, {useMemo, useState} from "react";
import {ICalibration} from "../../types/models/Calibration.ts";
import {CalibrationDialog} from "./CalibrationDialog.tsx";
import {Box} from "@mui/material";
import Statement from "../Statements/Statement.tsx";
import Boxel from "../Icons/Boxel.tsx";
import JobRest from "../../rest/JobRest.ts";
import {useQuery} from "@tanstack/react-query";
import {useWebsocketHandler} from "../WebsocketHandler/useWebsocketHandler.tsx";
import JobWebsocket from "../../websocket/JobWebsocket.ts";
import {CalibrationCard} from "./CalibrationCard.tsx";

export interface CalibrationsSliderProps {
    jobId: string;
    calibrations:  ICalibration[];
    fetchCalibrations?: () => void;
}

export function CalibrationsSlider(props: Readonly<CalibrationsSliderProps>) {

    const {jobId, calibrations, fetchCalibrations} = props;

    const [open, setOpen] = useState({});

    const jobRest = useMemo(() => new JobRest(), []);
    const jobWebsocket = useMemo(() => new JobWebsocket(), []);

    const job = useQuery({
        queryKey: ['jobs', jobId],
        queryFn: () => jobId ? jobRest.getById(jobId).then(res =>
            res.data.data) : null,
    });

    useWebsocketHandler({
        webSocketUrl: jobWebsocket.getAllUpdates(),
        refetch: job.refetch,
    })

    return (
        <CardGridSingleLineNew
            renderEmptyGrid={() => <Statement message={"No calibrations found"} icon={<Boxel/>}/>}
            cards={calibrations?.sort(
            (a: ICalibration, b: ICalibration) => {
                return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            }
            ).map(calibration => {
                if (!calibration) {
                    return null;
                }
                return <Box>
                    <CalibrationDialog
                        handleClose={() => setOpen(() => ({...open, [calibration._id]: false}))}
                        open={open[calibration._id] ?? false}
                        calibration={calibration}
                    />
                    <CalibrationCard
                        calibration={calibration}
                        job={job}
                        onclick={() => setOpen(() => ({...open, [calibration._id]: true}))}
                        jobRest={jobRest}
                        onJobPage={true}
                        fetchCalibrations={fetchCalibrations}
                    />
                </Box>
            }).filter(calibration => calibration !== null)
            }>
        </CardGridSingleLineNew>
    );
}